import { ValidationErrors, AbstractControl } from '@angular/forms';

export function emailValidator(control: AbstractControl): ValidationErrors | null {
  const value: string = control.value;

  if (!value) {
    return null;
  }

  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (!value.match(pattern)) {
    return { email: true };
  }

  return null;
}
